import { Modal, Button, Form, Row, FormGroup, FormLabel, Col, Spinner } from 'react-bootstrap'
import { Field, Formik } from 'formik'
import { useIntl } from 'react-intl'
import { OrderEdit } from '../../models/orderEdit'
import { ToastifyCaller, ToastifyType } from '../Toastify'
import { inputDateFormat } from '../../helpers/formatDate'
import { useMinExpeditionDate } from '../../hooks/useMinExpeditionDate'
import { useState } from 'react'
import { useQueryValidateOrders } from '../../hooks/useQueryValidateOrders'
import { requestChangeOrderExpeditionDate } from '../../requests/requests'

export const UpdateExpeditionDateModalMulti = ({
  show,
  onHide,
  refetch,
  changing,
  setChanging,
}: {
  show: string[]
  onHide: any
  refetch: any
  changing: boolean
  setChanging: any
}) => {
  const intl = useIntl()
  const { refetchValidateOrders } = useQueryValidateOrders(new Date())
  const [refetchedMinDate, setRefetchedMinDate] = useState(false)
  const [minExpeditionDate, maxExpeditionDate, refetchMinDate] = useMinExpeditionDate()
  const minDate = minExpeditionDate as Date
  const maxDate = maxExpeditionDate as Date
  const refetchMin = refetchMinDate as any

  if (!refetchedMinDate) {
    refetchMin()
    setRefetchedMinDate(true)
  }

  return (
    <Modal
      show={show ? true : false}
      onHide={onHide}
      dialogClassName='modal-dialog modal-dialog-centered modal-lg'
    >
      <Modal.Header closeButton>
        <h2 className='text-black'>
          {intl.formatMessage({ id: 'UPDATE_EXPEDITION_DATE_MODAL.TITLE' })}
        </h2>
      </Modal.Header>
      <Modal.Body className='modal-body py-lg-10 px-lg-20'>
        <Formik
          initialValues={{
            expeditionDate: inputDateFormat(minDate),
          }}
          onSubmit={async ({ expeditionDate }) => {
            if (show && expeditionDate) {
              const response = await requestChangeOrderExpeditionDate(show, expeditionDate)
              const allOK = response.status >= 200 && response.status
              if (allOK) {
                onHide()
                await refetch()
                await refetchValidateOrders()
                ToastifyCaller(
                  intl.formatMessage({ id: 'UPDATE_EXPEDITION_DATE_MODAL.UPDATE_OK' }),
                  ToastifyType.SUCCESS
                )
              }
            }
          }}
        >
          {({ handleSubmit, handleChange }) => (
            <Form onSubmit={(e) => {
              setChanging(true);
              handleSubmit(e);
            }}>
              <Row className='mb-12'>
                <Col xs='12'>
                  <FormGroup>
                    <Field
                      type='date'
                      id='expeditionDate'
                      name='expeditionDate'
                      className='form-control'
                      min={inputDateFormat(minDate.toDateString())}
                      max={inputDateFormat(maxDate.toDateString())}
                      onChange={(e) => {
                        handleChange(e)
                      }}
                    />
                    <FormLabel htmlFor='expeditionDate' />
                  </FormGroup>
                </Col>
              </Row>

              <div className='d-flex justify-content-end'>
                <Button
                  type='reset'
                  className='btn btn-secondary btm-sm mt-8  me-4'
                  onClick={onHide}
                >
                  {intl.formatMessage({ id: 'BUTTON.CANCEL' })}
                </Button>
                <Button variant='primary' type='submit' className={`btn btn-primary btm-sm mt-8`} disabled={changing}>
                  {intl.formatMessage({ id: 'BUTTON.SAVE' })}
                  {changing && <Spinner animation='border' className='mx-3' size='sm' />}
                </Button>
              </div>
            </Form>
          )}
        </Formik>
      </Modal.Body>
    </Modal>
  )
}
